<mat-form-field class="example-full-width" style="width: 100%;">
  <input matInput placeholder="{{holderText}}" value="{{value}}">
</mat-form-field>